export const SET_TIME_SORT = 'SET_TIME_SORT';
export const SET_SIZE_SORT = 'SET_SIZE_SORT';
export const ADD_UNINSTALL = 'ADD_UNINSTALL';
export const CANCEL_UNINSTALL = 'CANCEL_UNINSTALL';
export const SET_UNINSTALL_CATEGORY = 'SET_UNINSTALL_CATEGORY';
export const GET_UNINSTALL_CATEGORY = 'GET_UNINSTALL_CATEGORY';

export const GET_MIX_BATCH_DETAILS = 'GET_MIX_BATCH_DETAILS';
export const SET_MIX_BATCH_DETAILS = 'SET_MIX_BATCH_DETAILS';
export const SET_RRSIDUAL_LIST = 'SET_RRSIDUAL_LIST';
export const SET_TEMP_RRSIDUAL_LIST = 'SET_TEMP_RRSIDUAL_LIST';
export const MODIFY_RESIDUAL_DATA = 'MODIFY_RESIDUAL_DATA';
export const ADD_TEMP_RESIDUAL = 'ADD_TEMP_RESIDUAL';
export const ADD_TEMP_RESIDUAL_SUCC = 'ADD_TEMP_RESIDUAL_SUCC';
export const REMOVE_TEMP_RESIDUAL = 'REMOVE_TEMP_RESIDUAL';
export const REMOVE_TRESIDUAL = 'REMOVE_TRESIDUAL';
export const STOP_SCAN_RESIDUAL = 'STOP_SCAN_RESIDUAL';
export const STOP_DELETE_RESIDUAL = 'STOP_DELETE_RESIDUAL';
export const GET_RESIDUAL_MIX_BATCH_DETAILS = 'GET_RESIDUAL_MIX_BATCH_DETAILS';
